import { useFavorites } from '@bottlebooks/gatsby-plugin-bookmarks/src';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

export default function useRegistrations() {
  const favorites = useFavorites();
  const link = useLink();
  const exhibitorIds = useExhibitorIds();
  function isFavorite(registrationId: string | null | undefined) {
    const id = exhibitorIds.get(registrationId);
    if (!id) return false;
    return Boolean(favorites.get({ type: 'registration', id }));
  }
  return {
    isFavorite,
    toggleFavorite: (registrationId: string | null | undefined) => {
      const id = exhibitorIds.get(registrationId);
      if (!id) return false;
      if (isFavorite(registrationId)) {
        return favorites.unset({ type: 'registration', id });
      }
      return favorites.set({ type: 'registration', id });
    },
    getLink: (registrationId: string | null | undefined) => {
      const exhibitorId = exhibitorIds.get(registrationId);
      if (!exhibitorId) return undefined;
      return link.exhibitor({ exhibitorId });
    },
  };
}

function useExhibitorIds() {
  const data = useStaticQuery<UseRegistrationsQuery>(graphql`
    query UseRegistrations {
      allExhibitor {
        nodes {
          exhibitorId
          registration {
            registrationId
          }
        }
      }
    }
  `);
  const nodes = data.allExhibitor.nodes;
  return useMemo(() => {
    console.log('building map of registrationIds to exhibitorIds');
    if (!nodes) throw new Error('No registrations found');
    return new Map<string | undefined | null, string>(
      nodes.flatMap((node) =>
        node.exhibitorId
          ? [[node.registration?.registrationId, node.exhibitorId]]
          : []
      )
    );
  }, [nodes]);
}

type UseRegistrationsQuery = {
  allExhibitor: {
    nodes: {
      exhibitorId?: null | string;
      registration?: null | {
        registrationId?: null | string;
      };
    }[];
  };
};
